import { api } from "@/lib/api";

export const HR_CATEGORIES = {
  salary: "Lonen",
  holiday_pay: "Vakantiegeld",
  year_end_bonus: "Eindejaarspremie",
  individual_account: "Individuele rekeningen",
  contract: "Contracten",
  other: "Andere documenten",
};
export const HR_CATEGORY_ORDER = ["salary", "holiday_pay", "year_end_bonus", "individual_account", "contract", "other"];
export const HR_PAIRED = ["salary", "holiday_pay", "year_end_bonus"];
export const HR_ROLES = { statement: "Hoofddocument", payment_proof: "Storting", standalone: "Los document" };

export const HR_STATUS = {
  complete: { label: "Compleet", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  missing_payment: { label: "Storting ontbreekt", cls: "bg-amber-100 text-amber-700 border-amber-200" },
  missing_statement: { label: "Document ontbreekt", cls: "bg-amber-100 text-amber-700 border-amber-200" },
  problem: { label: "Probleem", cls: "bg-red-100 text-red-700 border-red-200" },
};

export const rolesForCategory = (cat) =>
  HR_PAIRED.includes(cat)
    ? ["statement", "payment_proof"]
    : ["individual_account", "contract"].includes(cat)
    ? ["standalone"]
    : ["statement", "payment_proof", "standalone"];

export const periodHint = (cat) => (cat === "salary" ? "JJJJ-MM (bv. 2026-05)" : "JJJJ of JJJJ-MM");

export async function openDocument(id, download = false) {
  const r = await api.get(`/hrdoc/documents/${id}/file`, {
    params: download ? { download: true } : {},
    responseType: "blob",
  });
  const url = URL.createObjectURL(r.data);
  if (download) {
    const a = document.createElement("a");
    a.href = url;
    a.download = `document-${id}.pdf`;
    a.click();
  } else {
    window.open(url, "_blank");
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export function saveBlob(data, filename) {
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
